import { render, staticRenderFns } from "./crew.vue?vue&type=template&id=11198248"
import script from "./crew.vue?vue&type=script&lang=js"
export * from "./crew.vue?vue&type=script&lang=js"
import style0 from "./crew.vue?vue&type=style&index=0&id=11198248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports